module.exports = __webpack_public_path__ + "img/player-empty.3cc93f05.svg";